import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import Localization from './Localization'
import reportWebVitals from './reportWebVitals'
import Router from './routes/Router'
import GlobalStyle from './utils/GlobalStyle'
import theme from './utils/theme'
import 'antd/lib/button/style/css'
import 'antd/lib/progress/style/css'
import 'antd/lib/col/style/css'
import 'antd/lib/row/style/css'
import 'antd/lib/grid/style/css'
import 'antd/lib/space/style/css'
import 'antd/lib/spin/style/css'
import 'antd/lib/layout/style/css'

ReactDOM.render(
  <Localization>
    <ThemeProvider theme={theme}>
      <Router />
      <GlobalStyle />
    </ThemeProvider>
  </Localization>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// remove from chunks after build
// not neccesary anymore: font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
// p{margin-bottom:1em; -> p{margin-bottom:0;
